const _excluded = ["title", "titleId"];
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 31.75 39.17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:2px;}.cls-2{fill:#fff;}")), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "lock") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "\u0428\u0430\u0440_2",
    "data-name": "\u0428\u0430\u0440 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\u0421\u043B\u043E\u0439_1",
    "data-name": "\u0421\u043B\u043E\u0439 1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1,
    y: 16.8,
    width: 29.75,
    height: 21.38,
    rx: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M6,16.8V9.42A10.25,10.25,0,0,1,15.63,1,10.26,10.26,0,0,1,26,9.42V16.8"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 15.96,
    cy: 25.21,
    r: 2.21
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "13.75 31.63 15.42 25.67 16.58 25.67 18.17 31.63 13.75 31.63"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.df114f2bac9262fdaa88d2cb113bf3ad.svg";
export { ForwardRef as ReactComponent };